module.exports = __webpack_public_path__ + "static/media/ad.cbd4ee22.jpg";